import { cardPreviewContext } from '@context/card-preview-context';
import { useContext } from 'react';

import { Address } from './components/Address';
import { Email } from './components/Email';
import { PhoneNumber } from './components/PhoneNumber';
import { Url } from './components/Url';
import type { CardAttributeType, CardField as CardFieldType } from '.cache/__types__';

type CardFieldProps = {
  cardId: string;
  // openInNewWindow?: boolean;
  size?: 'regular' | 'small' | 'extra-small';
  field: CardFieldType;
  index: number;
  cardAttributesTypes: CardAttributeType[];
  isDragDisabled?: boolean;
};

export const CardField = (props: CardFieldProps): JSX.Element | null => {
  const { hideEmptyAttributes } = useContext(cardPreviewContext);

  // if label and value don't exist and hideEmptyAttributes specified as true, show nothing
  if (!props.field.label && !props.field.value && hideEmptyAttributes) {
    return <></>;
  }

  switch (props.field.attribute_type?.name) {
    case 'address': {
      return <Address {...props} />;
    }
    case 'phone': {
      return <PhoneNumber {...props} />;
    }
    case 'email': {
      return <Email {...props} />;
    }
    default: {
      return <Url {...props} />;
    }
  }
};
